import classNames from 'classnames'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import archidekt from '@/assets/archidekt.svg'
import cardsphere from '@/assets/cardsphere.svg'
import csb from '@/assets/csb.svg'
import moxfield from '@/assets/moxfield.svg'
import mtgstocks from '@/assets/mtgstocks.svg'
import scryfall from '@/assets/scryfall.svg'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { PageCardType } from '@/types/card'

import styles from './OutboundBar.module.scss'

type Props = {
  card: PageCardType
}

const OutboundBar = ({ card }: Props) => {
  const archidektUri = `https://archidekt.com/search/decks?${card?.legal_commander ? 'commander' : 'card'}Name=${encodeURIComponent(card.names.join(' // '))}&deckFormat=3`
  const moxfieldUri = `https://moxfield.com/decks/public?format=commander&filter=${encodeURIComponent(card.name)}`
  return (
    <div className={styles.container}>
      {!card.is_partner && (
        <OverlayTrigger overlay={<Tooltip id='cardsphere'>Cardsphere</Tooltip>} placement='top'>
          <div className={styles.button}>
            <OutboundLink
              className={classNames('btn', styles.cardsphere)}
              url={`https://www.cardsphere.com/search?q=${encodeURIComponent(card.name).replace(/%20/g, '+')}`}
            >
              <img alt='Cardsphere' src={cardsphere.src} />
            </OutboundLink>
          </div>
        </OverlayTrigger>
      )}
      <OverlayTrigger overlay={<Tooltip id='archidekt'>Archidekt</Tooltip>} placement='top'>
        <div className={styles.button}>
          <OutboundLink className={classNames('btn', styles.archidekt)} url={archidektUri}>
            <img alt='Archidekt' src={archidekt.src} />
          </OutboundLink>
        </div>
      </OverlayTrigger>
      <OverlayTrigger overlay={<Tooltip id='spellbook'>Commander Spellbook</Tooltip>} placement='top'>
        <div className={styles.button}>
          <OutboundLink
            className={classNames('btn', styles.csb)}
            url={`https://commanderspellbook.com/search/?q=${encodeURIComponent(`card:"${card?.name}"`)}`}
          >
            <img alt='Commander Spellbook' src={csb.src} />
          </OutboundLink>
        </div>
      </OverlayTrigger>
      <OverlayTrigger overlay={<Tooltip id='moxfield'>Moxfield</Tooltip>} placement='top'>
        <div className={styles.button}>
          <OutboundLink className={classNames('btn', styles.moxfield)} url={moxfieldUri}>
            <img alt='Moxfield' src={moxfield.src} />
          </OutboundLink>
        </div>
      </OverlayTrigger>
      <OverlayTrigger overlay={<Tooltip id='scryfall'>Scryfall</Tooltip>} placement='top'>
        <div className={styles.button}>
          <OutboundLink className={classNames('btn', styles.scryfall)} url={card?.scryfall_uri}>
            <img alt='Scryfall' src={scryfall.src} />
          </OutboundLink>
        </div>
      </OverlayTrigger>
      {card?.prices?.mtgstocks?.url && (
        <OverlayTrigger overlay={<Tooltip id='mtgstocks'>MTGStocks</Tooltip>} placement='top'>
          <div className={styles.button}>
            <OutboundLink className={classNames('btn', styles.mtgstocks)} url={card.prices.mtgstocks.url}>
              <img alt='MTGStocks' src={mtgstocks.src} />
            </OutboundLink>
          </div>
        </OverlayTrigger>
      )}
    </div>
  )
}

export default OutboundBar
